import type { SupportDialogTypes } from "@core/features/support";
import { useDialog } from "@platform/store";
import { SupportTicketFormContainer } from "./SupportTicketFormContainer";
import { SupportSearchFormContainer } from "../../forms/SearchForm";

export function SupportDialogs() {
  const { activeDialog } = useDialog();

  if (!["supportTicket", "supportSearch"].includes(activeDialog || "")) {
    return null;
  }

  switch (activeDialog as SupportDialogTypes) {
    case "supportTicket":
      return <SupportTicketFormContainer />;
    case "supportSearch":
      return <SupportSearchFormContainer />;
    default:
      return null;
  }
}

export default SupportDialogs;

